import useTranslation from 'next-translate/useTranslation'
import { AccentButton, BlackButton } from '@/components/atoms/button'
import { Grid } from '@/components/atoms/Grid'
import Modal from '@/components/organisms/modal'
import styled, { css } from 'styled-components'
import { FC } from 'react'

type ConfirmProps = {
  title: string
  onDidTapClose: () => void
  onSubmit: (result: boolean) => void
}

const Confirm: FC<ConfirmProps> = ({ title, onDidTapClose, onSubmit }) => {
  const { t } = useTranslation('common')

  return (
    <Modal
      width={463}
      contentProps={{ padding: '15px 50px' }}
      onDidTapClose={onDidTapClose}
      title={title}
    >
      <Grid
        gridTemplateColumns="1fr 1fr"
        gridColumnGap={10}
        mt={30}
        justifyContent="space-between"
      >
        <StyledBlackButton
          title={t('Common.no')}
          onClick={() => onSubmit(false)}
        />
        <StyledAccentButton
          title={t('Common.yes')}
          onClick={() => onSubmit(true)}
        />
      </Grid>
    </Modal>
  )
}

export default Confirm

const UppercaseButton = css`
  text-transform: uppercase;
`

const StyledBlackButton = styled(BlackButton)`
  ${UppercaseButton}
`

const StyledAccentButton = styled(AccentButton)`
  ${UppercaseButton}
`
